import {InputBase, Paper} from "@mui/material";
import React from "react";
import {CiSearch} from "react-icons/ci";

interface SearchFieldProps {
    style?: React.CSSProperties;
    sx?: React.CSSProperties;
    handleSearchTicket: (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    searchValue?: string;
    placeHolder?: string;
}

const SearchField: React.FC<SearchFieldProps> = ({
                                                     style,
                                                     sx,
                                                     handleSearchTicket,
                                                     searchValue,
                                                     placeHolder,
                                                 }) => {
    return (
        <Paper
            component="form"
            onSubmit={(e) => e.preventDefault()}
            data-testid='search-field-paper'
            sx={{
                display: "flex",
                alignItems: "center",
                padding: "4px 4px 4px 8px",
                boxShadow: 0,
                border: "1px solid #D3D3DB",
            }}
            className="md:!w-full"
        >
            <InputBase
                placeholder={placeHolder}
                inputProps={{
                    style: {...style},
                }}
                sx={sx}
                value={searchValue}
                onChange={(event) => handleSearchTicket(event)}
            />
            <CiSearch color="gray" size={20}/>
        </Paper>
    );
};

export default SearchField;
